import { useConfig } from "../../context/config-context";
import Input from "../Inputs/Input";

export const InputPassword = ({
  id,
  register,
  fieldName = "password",
  error,
  label
}) => {
  const siteConfig = useConfig();

  return (
    <Input
      id={id}
      label={label || siteConfig.components.password.label}
      placeholder={siteConfig.components.password.placeholder}
      type="password"
      {...register(fieldName, {
        required: siteConfig.components.password.required,
        pattern: {
          value: siteConfig.pattern.password,
          message: siteConfig.components.password.invalid,
        },
      })}
      error={error}
    />
  );
};

export default InputPassword;
